import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
  },
  getters: {
    isLoading: state => state.isLoading
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
  },
  actions: {
    setLoading({ commit }, status) {
      commit('SET_LOADING', status);
    },
  },
  modules: {
  }
})
